import React from 'react';
import BaseComponent from './BaseComponent';
import Entries from './Entries';
import {connect} from 'react-redux';

export class PureEvent extends BaseComponent {
    render() {
        const {event} = this.props;

        return <div className="event">
            {this.renderInfo()}
            <Entries event={event} />
        </div>;
    }

    renderInfo() {
        const {event} = this.props;

        if (event.type === 'calendar') {
            return <div className="event-info">
                <h4>{event.name}</h4>
                <p>{event.start_time.format()}</p>
                <p>{event.description}</p>
            </div>;
        }

        return <div className="event-info">
            <h4>{event.name}</h4>
            <p>{event.start_time.format('ddd Do HH:mma')}</p>
            <dl>
                <dt>Adjudicator</dt>
                <dd>{event.adjudicator}</dd>
                {event.supervisor && <dt>Supervisor</dt>}
                {event.supervisor && <dd>{event.supervisor}</dd>}
            </dl>
        </div>;
    }
}

export default PureEvent;



/** WEBPACK FOOTER **
 ** ./src/components/Event.jsx
 **/